const groupFoodsByOption = (foods, branchId) => {
  const result = {}

  foods.forEach(food => {
    const { options, ...foodDetails } = food

    options.forEach(option => {
      const { inventories, ...restOfOption } = option

      const inventory =
        option.inventories.find(inv =>
          inv.isAvailable &&
          inv.branchId === branchId
        )

      if (!inventory) return

      result[option._id] = {
        ...foodDetails,
        isSimple: options.length === 1,
        option: {
          ...restOfOption,
          availableQuantity: inventory.availableQuantity,
          stockManagement: inventory.stockManagement,
          isAvailable: inventory.isAvailable,
          branchId: inventory.branchId
        }
      }
    })
  })

  return result
}

export default groupFoodsByOption